import RoutesUsersPage from "./RoutesUsersPage";

const module = {
  routeProps: {
    path: "RoutesUsers",
    component: RoutesUsersPage,
  },
  name: "Routes Users",
  label: "Routes Users",
  title: "Routes Users",
  showOnMenu: true,
};

export default module;
